import { is } from 'ramda';

import { AWS_AUDIO_PATH, S3_IMAGES_URL } from '../../config';

//The scope of this function is complete the absolute path of audio and image resources.
//In case some resources have already an absolute path the first part of the function strips from them.
export function getAbsolutePathforImageAndAudio(xml, imagePath = S3_IMAGES_URL, audioPath = AWS_AUDIO_PATH) {
    if (xml && is(String, xml)) {
        let xmlToReturn = xml;
        if (xmlToReturn.includes(imagePath) || xmlToReturn.includes(audioPath)) {
            return xml;
        }
        return xmlToReturn
            .replace(/<img.*?src="(?!http)/g, match => match.replace('src="', `src="${imagePath}`))
            .replace(/<source.*?src="(?!http)/g, match => match.replace('src="', `src="${audioPath}`))
            .replace(/<attachment type="image"><src>(?!http)/g, `<attachment type="image"><src>${imagePath}`)
            .replace(/<attachment type="audio"><src>(?!http)/g, `<attachment type="audio"><src>${audioPath}`);
    }
    return xml;
}

export function getAbsolutePathForAttachment(attachment, imagePath = S3_IMAGES_URL, audioPath = AWS_AUDIO_PATH) {
    if (!attachment) {
        return undefined;
    }
    if (attachment.type === 'image') {
        return {
            ...attachment,
            src: `${imagePath}${attachment.src}`
        };
    } else if (attachment.type === 'audio') {
        return {
            ...attachment,
            src: `${audioPath}${attachment.src}`
        };
    }
}

export function getRelativePathForImageAndAudio(xml, imagePath = S3_IMAGES_URL, audioPath = AWS_AUDIO_PATH) {
    if (xml) {
        let xmlToReturn = xml;
        return xmlToReturn
            .replace(new RegExp(`<img.*?src="${imagePath}`, 'gi'), match => match.replace(`src="${imagePath}`, 'src="'))
            .replace(new RegExp(`<source.*?src="${audioPath}`, 'gi'), match => match.replace(`src="${audioPath}`, 'src="'))
            .replace(new RegExp(`<attachment type="image"><src>${imagePath}`, 'gi'), '<attachment type="image"><src>')
            .replace(new RegExp(`<attachment type="audio"><src>${audioPath}`, 'gi'), '<attachment type="audio"><src>');
    }
    return xml;
}
